import __request__ from "routing/request";
export function records(page = 1, per_page = 20, sort = "started_at", order = "desc", query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/accounting/records", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function usage(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.llm/accounting/usage", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
